export default __webpack_public_path__ + "static/media/success.62b9c1a1.svg";